import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { Box, Flex } from 'rebass';
import { LegendItem, LegendLabel, LegendOrdinal } from '@visx/legend';
import React from 'react';
import { ScaleOrdinal } from 'd3-scale';

type LegendProps<T extends string = any> = {
  colorScale: ScaleOrdinal<T, string>;
  disabledKeys: Record<T, boolean | undefined>;
  toggleKey: (key: T) => void;
};

const Legend = <T extends string>({
  colorScale,
  disabledKeys,
  toggleKey,
}: LegendProps<T>) => (
  <LegendOrdinal
    scale={colorScale}
    labelFormat={constantToLabel as any}
    direction="row"
    labelMargin="0 15px 0 0"
  >
    {(labels: any[]) => (
      <Flex flexDirection="row" flexWrap="wrap">
        {labels.map((label, i) => (
          <Box
            key={`legend-quantile-${i}`}
            sx={{
              flexShrink: 0,
              whiteSpace: 'nowrap',
              opacity: disabledKeys[label.datum] ? 0.5 : 1,
              cursor: 'pointer',
              '&:hover': {
                opacity: disabledKeys[label.datum] ? 1 : 0.5,
              },
            }}
          >
            <LegendItem
              margin="0 5px"
              onClick={() => {
                // if (events) alert(`clicked: ${JSON.stringify(label)}`)
                toggleKey(label.datum);
              }}
            >
              <svg width={15} height={15}>
                <rect fill={label.value} width={15} height={15} />
              </svg>
              <LegendLabel align="left" margin="0 0 0 4px">
                {label.text}
              </LegendLabel>
            </LegendItem>
          </Box>
        ))}
      </Flex>
    )}
  </LegendOrdinal>
);

export default Legend;
